import React from 'react';
import './Service.css'
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Service = ({service}) => {
  const {id, name, img, price, desc} = service;
  const detailsPage = useNavigate();
  const handleServiceDetails = (id) => {
    detailsPage(`/service-details/${id}`)
  }
  return (
       <div className="col-sm-6 col-md-4">
       <div className="single_service">
          <div className='service_banner'>
          <img className='img-fluid' src={img} alt={name} />
          </div>
         <div className="service_info">
           <h4>{name}</h4>
           <p>{name} Photo Session</p>
         </div>
         <h5><small>$</small>{price}</h5>
         <p>{desc}</p>
         <Button onClick={()=>handleServiceDetails(id)} className='purches_button' >Purchase Now</Button>
         </div>
       </div>
  );
};

export default Service;